export type UserProfile = {
  civilite: CiviliteEnum;
  firstName: string;
  lastName: string;
  birthday: string;
  postalAddress: PostalAddressSettings;
  skypeId: string;
  telephoneFixe: string;
  telephonePortable: string;
  email1: string;
  email2: string;
}

export type PostalAddressSettings = {
  address: string;
  zipcode: string;
  city: string;
  country: string;
}

export enum CiviliteEnum {
  HOMME = 'M',
  FEMME = 'F'
}

export type AccountSettings = {
  renouvellement: string;
  serviceInclus: string[];
  numeroContrat: string;
  numeroSerie: string;
  adresseImei: string;
}

export type CommunicateSettings = {
  mailUnfilteredAttachmentAddedToDocuments?: boolean;
  mailFilteredAttachmentAddedToDocuments?: boolean;
  mailDisplaySignature?: boolean;
  mailUnreadFirst?: boolean;
  mailReadFullScreen?: boolean;
  mailDraftRemovalDelayInDays?: number;
  mailSpamRemovalDelayInDays?: number;
  mailSignature?: string;
}

export type SoundSettings = {
  soundOnButtonPush?: boolean;
  soundOnKeyPush?: boolean;
  soundOnAllowedMailReception?: boolean;
  soundOnForbiddenMailReception?: boolean;
  soundOnVideoCall?: boolean;
}

export type DisplaySettings = {
  interfaceMode?: string;
  theme?: string;
  screenBrightness?: number;
  standByDelay?: number;
  screenLock?: boolean;
}

export type QueryGetCommunicateSettingsResponse = {
  getDeviceSettings: {
    settings: CommunicateSettings;
  }
}

export type QueryGetSoundSettingsResponse = {
  getDeviceSettings: {
    settings: SoundSettings;
  }
}

export type QueryGetDisplaySettingsResponse = {
  getDeviceSettings: {
    settings: DisplaySettings;
  }
}